module.exports = __webpack_public_path__ + "img/house-city.e7418533.jpg";